<template>
  <div class="theme-toggle-wrapper">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :icon="iconOnly"
          :size="size"
          :aria-label="themeLabel"
          role="button"
          class="theme-toggle"
          v-bind="attrs"
          @click="toggleTheme"
          v-on="on"
        >
          <v-icon>{{ themeIcon }}</v-icon>
          <span v-if="!iconOnly" class="ml-2">
            {{ isDarkMode ? 'Dark' : 'Light' }}
          </span>
        </v-btn>
      </template>
      <span>{{ themeLabel }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ThemeToggle',

  props: {
    iconOnly: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['small', 'default', 'large'].includes(value),
    },
  },

  computed: {
    ...mapGetters('theme', ['isDarkMode']),

    themeIcon() {
      return this.isDarkMode ? 'mdi-weather-night' : 'mdi-weather-sunny'
    },

    themeLabel() {
      return this.isDarkMode 
        ? 'Switch to light mode' 
        : 'Switch to dark mode'
    },
  },

  methods: {
    toggleTheme() {
      this.$store.dispatch('theme/toggleTheme')
    },
  },
}
</script>

<style scoped>
.theme-toggle-wrapper {
  display: inline-block;
  width: 48px;
  height: 48px;
  position: relative;
}

.theme-toggle {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 48px !important;
  height: 48px !important;
  margin: 0 !important;
  padding: 0 !important;
}

.theme-toggle:hover {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}
</style>
